import { connect } from 'react-redux';
import { createSelector } from 'reselect';

// eslint-disable-next-line import/no-cycle
import { createLead } from './actions';
import {
  selectcaptureDirectorSuccess,
  selectcaptureDirectorErrorMessage,
} from '../../../selectors';
import CaptureDirector from './Component';

const mapStateToProps = createSelector(
  selectcaptureDirectorSuccess,
  selectcaptureDirectorErrorMessage,
  (isLeadCreated, errorMessage) => ({
    isLeadCreated,
    errorMessage,
  }),
);

function mapDispatchToProps(dispatch) {
  return {
    createLead: (data, callback) => dispatch(createLead(data, callback)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CaptureDirector);
